module.exports = __webpack_public_path__ + "media/images/smart_phone/chara_aichi-e42de52bfab94e41718d920c5580caa7.png";